import { render, staticRenderFns } from "./PassCard.vue?vue&type=template&id=0f1743cc&"
import script from "./PassCard.vue?vue&type=script&lang=js&"
export * from "./PassCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports